module.exports = __webpack_public_path__ + "static/headerRightBg-dfb002283532b7839b924cd1c32a03c9.png";